export enum SystemTotalType {
  Assets = 'assets',
  Locations = 'locations',
  Events = 'events',
}
